import { type Warning, type WarningQueryParams, WarningQueryParamsSchema, warningsEndpoints } from "../../../api";
import { useStrapiList, type UseStrapiListOptions } from "../../../hooks/strapi";
import getErrorMessage from "../../../utils/getErrorMessage";
import handleError from "../../utils/handleError";

type UseWarningsProps = UseStrapiListOptions;

const useWarnings = (props?: UseWarningsProps) => {
  const {
    items: warnings,
    setItems: setWarnings,
    refresh,
    isLoading,
    ...other
  } = useStrapiList<Warning>({
    ...props,
    load: (params) => {
      const parsed = WarningQueryParamsSchema.parse(params);
      return loadWarnings(parsed);
    },
    onLoadError: (err: unknown) => {
      handleError(getErrorMessage(err, "Warnings loading failed"));
    },
  });

  return {
    warnings,
    setWarnings,
    refresh,
    isLoading,
    ...other,
  };
};

export const loadWarnings = async (params?: WarningQueryParams) => {
  try {
    return await warningsEndpoints.getWarnings(params);
  } catch (err: unknown) {
    handleError(getErrorMessage(err, "Warnings loading failed"));
  }
};

export default useWarnings;
